var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPoisonPillBottle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.7 32.1",
    style: {
      enableBackground: "new 0 0 19.7 32.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#707070;}\n\t.st2{fill:#F77E0B;}\n\t.st3{fill:#1A1818;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    transform: "translate(-6332.82 -2042.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_728",
    transform: "translate(6337.4 2053.281)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 12,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st1",
    width: 11,
    height: 14
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2766",
    className: "st2",
    d: "M6333.5,2048c-0.6,0-0.4,1.4,0,1.4h1.4v23.6c0,0.3,0.2,0.5,0.5,0.5h14.3c0.3,0,0.5-0.2,0.5-0.5 v-23.6c0.5,0,1,0,1.5,0c0.4-0.1,0.5-1.4,0-1.4H6333.5z M6346.6,2066.4h-7.8v-11.3h7.8V2066.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2767",
    className: "st3",
    d: "M6333.4,2047.4c-0.6,0.5-0.7,1.3-0.4,1.9c0.7,1.3,1.3-0.1,1.7,0.5c0.5,0.8,0,3.6,0,4.6v14.5 c0,1-0.4,3,0,3.9c0.8,1.9,2.5,1.2,4.5,1.2h6.9c0.8,0,3.1,0.4,3.8,0c1.4-0.9,0.7-4,0.7-5.5v-14.1c0-1-0.5-3.7,0-4.6 c0.4-0.6,1.1,0.9,1.8-0.6c1.3-2.9-3.6-2-4.8-2h-14c-0.4,0-0.4,1.2,0,1.2h15.5c1.1,0,4.1,0.3,1.3,0.2c-0.2,0-0.3,0.5-0.3,0.6v16.5 c0,0.9,0.7,6.2,0,6.9c-0.8,0.8-6.1,0.1-7.4,0.1c-1.2,0-6.5,0.8-7.4,0c-0.6-0.6,0-5.7,0-6.5v-16.9c0-0.2,0-0.6-0.3-0.6 c-0.4,0.1-0.9,0-1.3-0.3C6333.9,2048.3,6333.8,2047.1,6333.4,2047.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2768",
    className: "st3",
    d: "M6346.6,2065.8h-7.8l0.3,0.6v-11.3l-0.3,0.6h7.8l-0.3-0.6v11.3c0,0.7,0.5,0.7,0.5,0v-11.3 c0-0.2,0-0.6-0.3-0.6h-7.8c-0.2,0-0.3,0.5-0.3,0.6v11.3c0,0.2,0,0.6,0.3,0.6h7.8C6347,2067,6347,2065.8,6346.6,2065.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2769",
    className: "st0",
    d: "M6350.7,2045.2v-1.6c0-0.5-0.4-1-1-1h-14.5c-0.5,0-1,0.4-1,1v1.6h-0.8c0,0-0.8,1.8,0,1.8h18.3 c0.5,0,0.1-1.7,0-1.8C6351.4,2045.1,6351.1,2045.1,6350.7,2045.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    className: "st3",
    d: "M6350.8,2045.2c0-1.5,0.2-2.2-1.3-2.7c-1.9-0.7-5.4,0-7.4,0c-1.7,0-5.2-0.7-6.9,0 c-1.3,0.5-1,2.5-1.8,2.5c0,0-0.1,0-0.1,0.1c-0.4,1.2-0.6,1.6,0.3,2.1c0.7,0.4,2.8,0,3.6,0h10.7c0.8,0,2.6,0.4,3.4,0 c0.9-0.4,0.9-1,0.4-2.1c0,0,0-0.1-0.1-0.1c-0.4-0.1-0.7-0.1-1.1,0c-0.1,0-0.1,0.4,0,0.4c1.2-0.1,1.2,1,0.4,1.4 c-0.6,0.1-1.3,0.1-1.9,0h-12.8c-0.7,0.1-1.4,0.1-2.1,0c-0.1,0-0.5,0.1-0.6,0c-0.2-0.2-0.2-1.4,0.5-1.4c0.1,0,0.1-0.2,0.1-0.2 c0-3.7,5.5-2.3,8.2-2.3h5.5c1.8,0,2.6,0.2,2.6,2.3C6350.6,2045.4,6350.8,2045.4,6350.8,2045.2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    x: 6332.8,
    y: 2042.2,
    className: "st4",
    width: 19.7,
    height: 32.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPoisonPillBottle);
export default __webpack_public_path__ + "static/media/icon-poison-pill-bottle.ff0395ca19a29894f5792d39f673c809.svg";
export { ForwardRef as ReactComponent };